<template>
  <div>

    <!-- 面包屑导航区 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>薪资管理</el-breadcrumb-item>
      <el-breadcrumb-item>薪资查询</el-breadcrumb-item>
    </el-breadcrumb>


    <el-form :inline="true" class="demo-form-inline">

      <el-form-item label="薪资月份">
        <el-col :span="11">
          <el-date-picker  type="month" placeholder="选择月份" v-model="queryData.uploadMonth"  value-format="timestamp" ></el-date-picker>
        </el-col>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="queryExcelTaskCategoryList" >查询</el-button>
      </el-form-item>
    </el-form>



      <el-row>
      <el-col :span="6" v-for="(item, index) in list" :key="index" :offset="1">
        <el-card  :body-style="{ padding: '0px' }" >
          <div style="padding: 14px;">
            <el-alert
              title="薪资文件-2020/02"

              :title="item.excelTaskName"
              type="success"
              effect="dark"   :closable="false">
            </el-alert>
            <el-divider></el-divider>
<!--            excelTaskName-->

            <el-row :gutter="20">
              <el-col :span="8"><i class="el-icon-date"><span style="margin-left: 2px;font-size: 13px;font-weight:bold">薪资月份:</span></i></el-col>
              <el-col :span="16" style="font-size: 13px;"> {{item.excelTaskTime}} </el-col>
            </el-row>
            <el-row style="margin-top: 5px" :gutter="20">
              <el-col :span="8"><i class="el-icon-date"><span style="margin-left: 2px;font-size: 13px ;font-weight:bold">部门:</span></i></el-col>
              <el-col :span="16" style="font-size: 13px "> {{item.departmentName}} </el-col>
            </el-row>
            <el-row style="margin-top: 5px" :gutter="20">
              <el-col :span="8"><i class="el-icon-date"><span style="margin-left: 2px;font-size: 13px;font-weight:bold ">类型:</span></i></el-col>
              <el-col :span="16" style="font-size: 13px "> {{item.typeName}} </el-col>
            </el-row>
            <el-row style="margin-top: 5px" :gutter="20">
              <el-col :span="8"><i class="el-icon-date"><span style="margin-left: 2px;font-size: 13px;font-weight:bold ">上传人数:</span></i></el-col>
              <el-col :span="16" style="font-size: 13px "> {{item.peopleNumber}} </el-col>
            </el-row>

            <el-row style="margin-top: 5px" :gutter="20">
              <el-col :span="8"><i class="el-icon-date"><span style="margin-left: 2px;font-size: 13px;font-weight:bold ">创建时间:</span></i></el-col>
              <el-col :span="16" style="font-size: 13px "> {{item.createTime}} </el-col>
            </el-row>

            <el-divider><i class="el-icon-setting"></i></el-divider>

            <div class="bottom clearfix">
<!--              <el-button type="text" class="button" >查看</el-button>-->

<!--              <el-button type="text" class="button" >删除</el-button>-->

              <el-row  :gutter="20">
                <el-col :span="4"><el-button type="text" class="button" @click="querySalary(item)" >查看</el-button></el-col>
                <el-col :span="4"> <el-button type="text" class="button" @click="deleteSalary(item)" >删除</el-button></el-col>
                <el-col :span="4"> <el-button type="text" class="button" @click="showNoticeRemark(item)" >公告</el-button></el-col>
              </el-row>




            </div>
          </div>
        </el-card>

      </el-col>
    </el-row>


    <el-dialog title="公告" :visible.sync="dialogFormVisible">
      <el-form :model="updateRemarkForm">
        <el-form-item label="公告内容" >
          <el-input v-model="updateRemarkForm.remark"   type="textarea" :autosize="{ minRows: 4, maxRows: 4}" @input="change($event)" ></el-input>
        </el-form-item>
      </el-form>


      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateNoticeRemark()">确 定</el-button>
      </div>
    </el-dialog>

  </div>




</template>

<script>
  let Base64 = require('js-base64').Base64

  export default {
    data() {
      return {
        queryData:{
          departmentId:-9999,
          type:null,
          uploadMonth:null
        },

        list:[

        ],
        delForm:{},
        dialogFormVisible:false,
        updateRemarkForm:{}
      };
    },

    methods: {
      async queryExcelTaskCategoryList(){
        const { data: res } = await this.$http.post('/mainSalary/queryExcelTaskCategoryList',this.queryData)   //get参数用params获得
        console.log(res);
        if(res.code !== '10000') {
          return this.$message.error(res.msg);
        }

        this.list = res.data;

      },
      async deleteSalary(item){
        console.log(item);

        // 弹框询问商品是否删除数据
        const confirmResult = await this.$confirm('此操作将永久删除该薪资文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).catch(err => {
          return err
        })
        // 如果商品确认删除，则返回值为字符串 confirm
        // 如果商品取消删除，则返回值为字符串 cancle（需要用catch捕获）
        // console.log(confirmResult)
        if (confirmResult !== 'confirm') {
          return this.$message.info('已取消删除')
        }

        const excelTaskCategoryId =  item.excelTaskCategoryId;

        this.delForm.excelTaskCategoryId = excelTaskCategoryId;
        const { data: res } = await this.$http.post('/mainSalary/delMonthSalaryDataV2',this.delForm)

        if(res.code != '10000') {
          return this.$message.error(res.msg);
        }else{
          this.$message.success('删除成功')
          // 重新获取列表数据
          this.queryExcelTaskCategoryList();
        }

      },
      querySalary(item){
        var excelTaskCategoryId = Base64.encodeURI(item.excelTaskCategoryId+"");
        // var id2 = Base64.decode(id1);
        this.$router.push({ path: "/salary/salaryDetails/"+excelTaskCategoryId})
      },
      /**
       * 显示公告信息进行赋值
       */
      showNoticeRemark(item){
        this.dialogFormVisible = true;
        this.updateRemarkForm.remark = item.remark;
        this.updateRemarkForm.excelTaskCategoryId= item.excelTaskCategoryId;
      },
      /**
       * 更新公告信息
       * @param item
       * @returns {Promise<ElMessageComponent>}
       */
      async updateNoticeRemark(){
        const { data: res } = await this.$http.post('/salaryExcel/updateExcelTaskCategory',this.updateRemarkForm)
        if(res.code != '10000') {
          return this.$message.error(res.msg);
        }else{
          this.$message.success('修改成功')
          // 重新获取列表数据
          this.queryExcelTaskCategoryList();
          this.dialogFormVisible = false;
        }
      },
      change(e){
        this.$forceUpdate()
      }

    },
    created () {
      this.queryExcelTaskCategoryList();
    },
  }
</script>

<style lang="less" scoped>
  .el-card-define {
    min-height: 100%;
    height: 100%;

  }

  .demo-form-inline{
    margin-top: 20px;
  }


</style>



// WEBPACK FOOTER //
// src/components/salary/SalaryList.vue